import './CategoryCard.css';

export interface CategoryCardProps {
  title: string;
  image?: string;
  bgColor?: string;
}

export default function CategoryCard({
  title,
  image,
  bgColor = '#daf7f4',
}: CategoryCardProps) {
  return (
    <div className="category-card" style={{ backgroundColor: bgColor }}>
      <h3 className="category-card__title">{title}</h3>
      {image && (
        <div className="category-card__image">
          <img src={image} alt={title} />
        </div>
      )}
    </div>
  );
}
